import * as React from 'react'
import {FC} from 'react'
import {observer} from 'mobx-react'
import {useStores} from '../../../../lib/MobXProvider'
import {WidgetApi} from '../../../../lib/WidgetApi'
import {BlockProps} from '../../../../lib/Block'
import {PaymentPurposes} from '../elements/PaymentPurposes'

///////////////////////////////////////////////////////////////////////////////

export const PaymentPurposesBlock: FC<BlockProps> = observer((props) => {
  const {api} = useStores<{api: WidgetApi}>()
  const {position} = props

  return (
    <section className="widget-block payment-purposes-block">
      <div className="widget-block-header">
        <h2 className="title">
          <span className="position">{position}</span>
          <span className="text">
            {api.trans('blocks.payment_purposes.title')}
          </span>
        </h2>
      </div>

      <div className="widget-block-content">
        <PaymentPurposes />
      </div>
    </section>
  )
})
